'use client';

import { useDraw } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import { getFormattedDateAndTime } from '@svs/nova-poolbetting/core/lib/client';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import { useCountdown } from '@svs/nova-poolbetting/ui/DrawManager/client';
import type { ReactNode } from 'react';

type DrawCardCloseTimeManagerProps = {
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
  isMyBetsOrResult: boolean;
};

/**
 * Props for DrawCardCloseTimeManager component.
 *
 * @param root0 Component props
 * @param root0.drawNumber Draw number to load draw from
 * @param root0.product Product number to load draw from
 * @param root0.isMyBetsOrResult Flag indicating if the component is used in the context of "My Bets" or "Result"
 * @returns React node as presentational component
 */
export function DrawCardCloseTimeManager({
  drawNumber,
  product,
  isMyBetsOrResult,
}: DrawCardCloseTimeManagerProps): ReactNode {
  const drawData = useDraw(
    { drawNumber, product },
    {
      select: (data) => {
        return { regCloseTime: data.draw.regCloseTime, cancelCloseTime: data.draw.cancelCloseTime };
      },
    }
  );
  const timeToUse = isMyBetsOrResult ? drawData.data.cancelCloseTime : drawData.data.regCloseTime;
  const countdownString = useCountdown({
    targetDateTime: timeToUse,
  });

  const formatedRegClosetime = getFormattedDateAndTime(timeToUse, {
    shouldUseNameOfDay: true,
    shouldCapitalizeFirstLetter: true,
    dateFormatOptions: 'dayAsDateMonthAsText',
    timeFormatOptions: 'hourMinute',
    formatOptions: 'dateAndTime',
  });
  return countdownString ?? formatedRegClosetime;
}
